/**
 * Home template
 * This file contains logic specific to a template.
 * It is intended to ONLY be loaded on templates that require
 * this specific functionality.
 **/

import Global from './lib/global';
import Logger from './lib/logger';
import KeenSlider from 'keen-slider';
import ThemeBlogGrid from './partials/ThemeBlogGrid';

// Vars
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

const NAME = 'Home';

const heroSlider = document.querySelector('[data-hero-slider]');
const heroSliderActiveClass = 'home-hero__slides--active';
const heroSliderSlideSelector = '.home-hero-slide';
const heroSliderPaginationDots = document.querySelectorAll('[data-hero-slider-pagination-dot]');
const heroSliderPaginationDotActiveClass = 'home-hero__pagination-dot--active';

let recentThemeBlogGrid;
const recentArticles = document.querySelector('#recent-articles');
const recentThemeBlogGridDom = recentArticles.querySelector('[data-theme-blog-grid]');

// Logic
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

/**
 * Initialize everything
 **/
const init = () => {
	Logger.info(`${NAME} > init`);
	initHeroSlider();
	initRecentThemeBlogGrid();
}

/**
 * Initialize the hero slider
 **/
const initHeroSlider = () => {

	Logger.info(`${NAME} > initHeroSlider`);

	const slider = new KeenSlider(heroSlider, {
		selector: heroSliderSlideSelector,
    loop: true,
    created: () => {
    	Logger.info(`${NAME} > initHeroSlider > created`);
    },
    slideChanged: (props) => {
    	const idx = props.track.details.rel;
    	Logger.info(`${NAME} > initHeroSlider > slideChanged > ${idx}`);

    	heroSliderPaginationDots.forEach((item,i) => {
    		if(i === idx) {
	    		item.classList.add(heroSliderPaginationDotActiveClass);
    		} else {
	    		item.classList.remove(heroSliderPaginationDotActiveClass);
	    	}
    	});
    }
  },[
    (slider) => {
      let timeout
      let mouseOver = false
      function clearNextTimeout() {
        clearTimeout(timeout)
      }
      function nextTimeout() {
        clearTimeout(timeout)
        if (mouseOver) return
        timeout = setTimeout(() => {
          slider.next()
        }, 8000)
      }
      slider.on("created", () => {
      	heroSlider.classList.add(heroSliderActiveClass);
        slider.container.addEventListener("mouseover", () => {
          mouseOver = true
          clearNextTimeout()
        })
        slider.container.addEventListener("mouseout", () => {
          mouseOver = false
          nextTimeout()
        })
        nextTimeout()
      })
      slider.on("dragStarted", clearNextTimeout)
      slider.on("animationEnded", nextTimeout)
      slider.on("updated", nextTimeout)
    },
  ]);

  heroSliderPaginationDots.forEach((item,i) => {
  	item.addEventListener('click', (e) => {
  		e.preventDefault();
  		slider.moveToIdx(i);
  	});
  });
}

/**
 * Init the Theme Blog Grid as infinite scroll
 **/
const initRecentThemeBlogGrid = () => {
	Logger.info(`${NAME} > initRecentThemeBlogGrid`);
	recentThemeBlogGrid = new ThemeBlogGrid(
		recentThemeBlogGridDom
	);
}

// Bootstrap global functionality
Global();

init();

// Do not edit below this line...
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
Logger.info(`${NAME} > loaded`);
